import { useState } from "react";

export const useConfirmableAction = () => {
	const [isActionOpen, setIsActionOpen] = useState(false);
	const [isConfirmOpen, setIsConfirmOpen] = useState(false);

	return {
		isActionOpen,
		isConfirmOpen,
		openAction: () => setIsActionOpen(true),
		closeAction: () => setIsActionOpen(false),
		requestConfirm: () => {
			setIsActionOpen(false);
			setIsConfirmOpen(true);
		},
		closeConfirm: () => setIsConfirmOpen(false),
	};
};
